(function () {
  if (window.__bnlPdpMotion) return;
  window.__bnlPdpMotion = true;

  function ready(fn) {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fn);
    else fn();
  }

  /* Hide variant options that only have one choice (e.g. a single kit style) */
  function hideSingleOptions() {
    document.querySelectorAll('variant-picker fieldset, variant-picker .variant-option').forEach(function (f) {
      var choices = f.querySelectorAll('input[type="radio"], option');
      if (choices.length && choices.length < 2) f.hidden = true;
    });
    document.querySelectorAll('variant-picker').forEach(function (vp) {
      var opts = vp.querySelectorAll('fieldset, .variant-option');
      var visible = Array.prototype.filter.call(opts, function (o) { return !o.hidden; });
      if (opts.length && !visible.length) vp.hidden = true;
    });
  }

  /* 1. Sticky add-to-cart bar: add a perks line and a text label on mobile */
  function stickyNote() {
    var cfg = document.querySelector('[data-bnl-motion]');
    var bar = document.querySelector('.sticky-add-to-cart__bar');
    if (!bar || !cfg) return;
    bar.classList.add('bnl-sticky');
    if (cfg.getAttribute('data-sticky-label') === 'true') bar.classList.add('bnl-sticky--label');
    var note = cfg.getAttribute('data-sticky-note');
    var info = bar.querySelector('.sticky-add-to-cart__info');
    if (note && info && !info.querySelector('.bnl-sticky-note')) {
      var el = document.createElement('div');
      el.className = 'bnl-sticky-note';
      el.textContent = note;
      info.appendChild(el);
    }
  }

  ready(function () {
    hideSingleOptions();
    stickyNote();
    var bar = document.querySelector('.sticky-add-to-cart__bar');
    if (bar && window.MutationObserver) {
      new MutationObserver(function () {
        if (!bar.querySelector('.bnl-sticky-note')) stickyNote();
      }).observe(bar, { childList: true, subtree: true });
    }

    if (!document.documentElement.classList.contains('bnl-motion')) return;

    /* 5. Gentle reveals */
    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) {
            e.target.classList.add('is-in');
            io.unobserve(e.target);
          }
        });
      },
      { rootMargin: '0px 0px -8% 0px', threshold: 0.12 }
    );

    function prep(selector, step, rowSize) {
      document.querySelectorAll(selector).forEach(function (el) {
        if (el.classList.contains('bnl-rv')) return;
        var idx = Array.prototype.indexOf.call(el.parentNode.children, el);
        if (rowSize) idx = Math.floor(idx / rowSize);
        el.style.setProperty('--bnl-d', Math.min(idx, 6) * step + 'ms');
        el.classList.add('bnl-rv');
        io.observe(el);
      });
    }
    prep('.bnl .bnl-head', 0);
    prep('.bnl-calm__media, .bnl-love__media, .bnl-cta, .bnl-eve__tip, .bnl-box__foot', 0);
    prep('.bnl-calm__list > li, .bnl-ticks > li, .bnl-box__tile, .bnl-need__item, .bnl-faq__item, .bnl-products > .bnl-card', 90);

    /* 3. Tabs close one by one, then the kit lights up */
    document.querySelectorAll('.bnl-calm__tabs').forEach(function (wrap) {
      var tabs = wrap.querySelectorAll('.bnl-calm__tab:not(.bnl-calm__tab--on)');
      tabs.forEach(function (t, i) { t.style.setProperty('--i', i); });
      var on = wrap.querySelector('.bnl-calm__tab--on');
      if (on) on.style.setProperty('--on-d', tabs.length * 380 + 350 + 'ms');
      wrap.classList.add('bnl-tabs-anim');
      io.observe(wrap);
    });

    /* 2. Lights-on photo and 4. build timeline, driven by scroll position */
    var glows = [].slice.call(document.querySelectorAll('.bnl-love__media'));
    glows.forEach(function (g) {
      var chip = document.createElement('span');
      chip.className = 'bnl-glow-chip';
      chip.setAttribute('aria-hidden', 'true');
      chip.textContent = 'Lights off';
      g.appendChild(chip);
      g.setAttribute('data-glow', '');
    });
    var eves = [].slice.call(document.querySelectorAll('.bnl-eve'));
    eves.forEach(function (s) { s.classList.add('bnl-eve--anim'); });

    function clamp(v) { return v < 0 ? 0 : v > 1 ? 1 : v; }
    var ticking = false;
    function update() {
      ticking = false;
      var vh = window.innerHeight || 800;
      glows.forEach(function (g) {
        var r = g.getBoundingClientRect();
        var p = clamp((vh * 0.95 - r.top) / (vh * 0.5));
        g.style.setProperty('--p', p.toFixed(3));
        var lit = p > 0.85;
        if (g.classList.contains('is-lit') !== lit) {
          g.classList.toggle('is-lit', lit);
          var chip = g.querySelector('.bnl-glow-chip');
          if (chip) chip.textContent = lit ? 'Lights on' : 'Lights off';
        }
      });
      eves.forEach(function (s) {
        var grid = s.querySelector('.bnl-eve__grid');
        if (!grid) return;
        var r = grid.getBoundingClientRect();
        var p = clamp((vh * 0.85 - r.top) / Math.max(r.height, vh * 0.45));
        s.style.setProperty('--p', p.toFixed(3));
        var cards = s.querySelectorAll('.bnl-eve__card');
        cards.forEach(function (c, i) { c.classList.toggle('is-lit', p > (i + 0.35) / cards.length); });
      });
    }
    function onScroll() {
      if (!ticking) {
        ticking = true;
        requestAnimationFrame(update);
      }
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    update();
  });
})();
